// Constants for CreateTicket module

// Slot types enum - defines the types of slots that can be booked
export const SLOT_TYPES = {
    CUSTOMER_COMPLAINT: 'CUSTOMER_COMPLAINT',
    MEDICAL_ESCALATION: 'MEDICAL_ESCALATION'
};

export const REGIONAL_LANGUAGES = ['TAMIL', 'TELUGU', 'KANNADA', 'ENGLISH'];

// Hair Coach Issues -> Slot not Catered is the only combination that carries the two-option
// resolution flow, so it is matched on the category/subcategory keys rather than on a config flag.
export const HAIR_COACH_ISSUES = 'hair_coach_issues';
export const SLOT_NOT_CATERED = 'slot_not_catered';

export const SLOT_NOT_CATERED_RESOLUTION = {
    RESOLVED: 'resolved',
    NEEDS_COACH: 'needs_coach'
};

// Both branches close the ticket in the same flow, so the closing note is the only record of WHY it
// was closed the moment it was raised. Kept internal — a customer-facing comment is what emits the
// ticket_customer_facing_comment_added event this subcategory deliberately suppresses.
export const SLOT_NOT_CATERED_CLOSING_NOTE = {
    [SLOT_NOT_CATERED_RESOLUTION.RESOLVED]:
        'Customer concern resolved during the interaction. Ticket auto-closed from CRM.',
    [SLOT_NOT_CATERED_RESOLUTION.NEEDS_COACH]: (slotLabel) =>
        `Coach slot booked for ${slotLabel}. The coach will connect with the customer as per the booked slot. Ticket auto-closed from CRM.`
};